import { useMemo } from 'react'
import TableItem from '@/components/Table'
import { TABLE_HEADERS_RESUMO_TAB } from '@/pages/Pedidos/constants'

const DetalhesImportacaoDevolucoes: React.FC<{ detalhesImportacao: any }> = ({ detalhesImportacao }) => {
  const mapedProperties = useMemo(() => {
    return [{
      depositosBancarios: detalhesImportacao?.itensDepositoBancario || 0,
      reprocessados: detalhesImportacao?.itensReprocessamento || 0,
      desconto: detalhesImportacao?.itensDescontarNaProximaFatura || 0,
    }]
  }, [detalhesImportacao])

  return (
    <div className='p-5'>
      <TableItem
        isActions={false}
        isRowClicable={false}
        data={mapedProperties || []}
        headers={TABLE_HEADERS_RESUMO_TAB}
        deleteAction={() => void 0}
        hasCustomActions={false}
        idKey='id'
        isIdle={false}
      />
    </div>
  )
}

export default DetalhesImportacaoDevolucoes
